<div class="modal-size" role="dialog">
  <gstar-header-modal [id]="modalId">
    @if (success) {
      <ap-badge
        [value]="'notifications.importBadgeSuccess' | translate"
        type="success"
        size="large"></ap-badge>
      {{ modalTitle }}
    } @else {
      <ap-badge
        [value]="'error-notifications.title' | translate"
        type="danger"
        size="large"></ap-badge
      >{{
        'notifications.importModalErrorTitle' | translate: { fileName: title }
      }}
    }
  </gstar-header-modal>
  @if (messageList().length) {
    <gstar-body-modal>
      <ul>
        @for (message of messageList(); track $index) {
          <li>
            {{ message }}
          </li>
        }
      </ul>
    </gstar-body-modal>
  }
  <gstar-footer-modal
    [id]="modalId"
    [primaryButtonLabel]="'shared.continue' | translate"
    [hideSecondaryButton]="true" />
</div>
